import React, { Component } from 'react';
import Nav from '../components/Nav';
import GetTheApp from '../components/GetTheApp';
import Features from '../components/Features';
import Footer from '../components/Footer';

import characterImage from '../assets/images/character.gif';

class Home extends Component {

  render() {
    return (
      <div className="Home">

        <div className="media-photo media-photo-block space-1">
          <div
             className="media-cover media-cover-dark media-cover-blue background-cover background-building">
          </div>

          <Nav homepage/>

          <div className="page-container-responsive">
            <div className="va-container va-container-v va-container-h">
              <div className="va-middle text-contrast">
                <div className="space-5 space-top-3">
                  <h1 className="space-3">No more missed packages.</h1>
                  <h1 className="space-3">No more locked-out friends.</h1>
                  <h1 className="space-5 extra-space-lg"><b>Get  Tiny Doorman, your personal doorman app.</b></h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-container-responsive">
          <div className="row space-top-5 space-5 space-top-sm-3 space-sm-4">
            <div className="col-sm-12 col-md-12">
              <h2 className="space-4">
                Building intercoms have a simple job. <br className="hide-sm"/>
                Let the right people in, <br className="hide-sm"/>and keep the wrong people out.
              </h2>
              <h2 className="space-4">
                Yet they don't seem to work that way.
              </h2>
              <h3>It's too easy to miss the delivery person's intercom call and end up with a dreaded door tag. And just as easy for unauthorized people to get into any building just by dialing units and claiming to be someone with a delivery.</h3>
            </div>
          </div>
        </div>

        <div className="background-blue text-contrast">
          <div className="page-container-responsive">
            <div className="row space-top-5 space-top-sm-3">
              <div className="col-sm-12 col-md-6">
                <h2 className="space-3"><b>Tiny Doorman is <br className="hide-sm"/>here to help.</b></h2>
                <h3 className="space-4">Tiny Doorman answers your intercom calls and lets authorized people in - all without bothering you.  Create and send a key code with just a few clicks, or create and list a key code in package and food delivery notes, and Tiny Doorman will verify the codes and let visitors in for you.</h3>
              </div>

              <div className="space-top-4 col-sm-12 col-md-4 col-offset-2 text-center">
                <img src={characterImage} alt="Tiny Doorman"/>
              </div>
            </div>
          </div>
        </div>

        <Features />

        <hr className="space-top-0" />

        <div className="page-container-responsive">
          <div className="row space-top-5 space-top-sm-3">
            <div className="col-sm-12 col-md-4 text-center">
              <div className="point point-download"></div>
              <h3 className="space-4">Download the app and follow the onboarding instructions.</h3>
              <hr className="show-sm" />
            </div>
            <div className="col-sm-12 col-md-4 text-center">
              <div className="point point-phone"></div>
              <h3 className="space-4">Ask your property manager to change your intercom number to the number we provide.</h3>
              <hr className="show-sm" />
            </div>
            <div className="col-sm-12 col-md-4 text-center">
              <div className="point point-keys"></div>
              <h3 className="space-5 space-sm-4">Start designating your virtual keys to your trusted parties!</h3>
            </div>
          </div>
        </div>

        <GetTheApp />
        <Footer />
      </div>
    );
  }
}

export default Home;



/** WEBPACK FOOTER **
 ** ./src/pages/Home.js
 **/